module.exports = __webpack_public_path__ + "img/SWP_Sword_1H_04 (2).6de36466.png";